import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { black, footerColorGray, white } from '@Constants/ThemeColor'
import { Row } from 'antd'

export const StyledLink = styled(Link)`
  display: flex;
  font-size: 1rem;
  margin: 0 1rem;
  text-decoration: none;
  color: ${white};
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`

export const StyledaTag = styled.a`
  display: flex;
  font-size: 1rem;
  margin: 0 1rem;
  text-decoration: none;
  color: ${white};
  &:focus,
  &:hover,
  &:visited,
  &:a,
  &:active {
    text-decoration: none;
  }
`

export const Copyright = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${black};
  height: 40px;
  color: ${white};
`
export const FooterIcon = styled.div(
  (props) => `
    width: 100%;
    display: flex;
    ${!props.xs ? `justify-content: space-between;` : ''}
    ${props.lg ? `float: right;` : ''}
    ${props.xs ? `margin: 0 1rem; flex-direction: column;` : ''}

    .innterImage{
      display: flex;
      flex-direction: column;
      img{
        margin-bottom: 0.5rem;
      }
    }
    .img1{
      width: 8.4rem;
      height: 2.5rem;
    }
    .img2{
      width: 5rem;
    }
    @media (min-width: 300px) and (max-width: 575px) {
      img{
        margin-bottom: 1rem;
      }
    }
    @media (min-width: 576px) and (max-width: 1100px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        margin-bottom: 1rem;
      }
    }
  `
)

export const FooterRow = styled(Row)`
  background-color: ${footerColorGray};
  color: ${white};
  min-height: 6rem;
  display: flex;
  align-items: center;
  padding: ${(props) =>
    props?.xs ? '.3rem .3rem' : props?.sm ? '1rem 3rem' : '1rem 5rem'};
`
